"use client";

import { type ReactNode, Suspense } from "react";
import { GlobalEmbedPlayerDockLazy } from "@/components/global-embed-player/global-embed-player-dock-lazy";
import { RouteScrollReset } from "@/components/navigation/route-scroll-reset";
import { RouterRefreshBridge } from "@/components/navigation/router-refresh-bridge";
import { GlobalEmbedPlayerProvider } from "@/context/global-embed-player-context";
import { GlobalPlayerProvider } from "@/context/global-player-context";

/** Client providers for the `(main)` segment — single boundary for the server layout. */
export function MainLayoutProviders({ children }: { children: ReactNode }) {
	return (
		<GlobalEmbedPlayerProvider>
			<GlobalPlayerProvider>
				<RouterRefreshBridge />
				<Suspense fallback={null}>
					<RouteScrollReset />
				</Suspense>
				{children}
				<GlobalEmbedPlayerDockLazy />
			</GlobalPlayerProvider>
		</GlobalEmbedPlayerProvider>
	);
}
